import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';

function TableContent(props){

    

    const _TableAction = (record) => {
        const { tableAction } = props;
        // 当为禁用或拉黑时，显示为'启用'
        const disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('available', record)}>{disable ? '启用' : '禁用'}</div>
            </div>
        );
    };

    const columns = [
        {
            title: '手机号码',
            dataIndex: 'tel',
            key: 'tel',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => {
                props.tableAction('detail', record);
            })
        },
        {
            title: '骑士名称',
            dataIndex: 'nickname',
            key: 'nickname',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推荐来源',
            dataIndex: 'referrerRoleValue',
            key: 'referrerRoleValue',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '服务城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士状态',
            dataIndex: 'stateValue',
            key: 'stateValue',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '工作状态',
            dataIndex: 'workStateValue',
            key: 'workStateValue',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '接单数量',
            dataIndex: 'receiveOrderCount',
            key: 'receiveOrderCount',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '注册时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '200px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: cellWidth.time,
            fixed: 'right',
            render: (id, record) => _TableAction(record)
        },
    ];

    const { paginationChange } = props;
    const { pageNum, pageSize, resultTotal, dataList } = props.renderData;

    return (
        <div className={styles.tableContainer} style={{ height: '100%' }}>
            <Table
                rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                rowKey={(r) => r.id}
                columns={columns}
                dataSource={dataList}
                pagination={false}
                scroll={{ y: true }}
            />
            <XPagination
                resultTotal={resultTotal}
                pageSize={pageSize}
                pageNum={pageNum}
                onChange={paginationChange}
            />
        </div>
    );
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableContent;